/* tslint:disable */
import {
  QualityMeasure
} from '../index';

declare var Object: any;
export interface QualityMeasureValueInterface {
  "id"?: number;
  "name"?: string;
  "is_custom"?: boolean;
  "measure_id"?: number;
  measureId?: QualityMeasure;
}

export class QualityMeasureValue implements QualityMeasureValueInterface {
  "id": number;
  "name": string;
  "is_custom": boolean;
  "measure_id": number;
  measureId: QualityMeasure;
  constructor(data?: QualityMeasureValueInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `QualityMeasureValue`.
   */
  public static getModelName() {
    return "QualityMeasureValue";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of QualityMeasureValue for dynamic purposes.
  **/
  public static factory(data: QualityMeasureValueInterface): QualityMeasureValue{
    return new QualityMeasureValue(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'QualityMeasureValue',
      plural: 'QualityMeasureValues',
      path: 'QualityMeasureValues',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "is_custom": {
          name: 'is_custom',
          type: 'boolean'
        },
        "measure_id": {
          name: 'measure_id',
          type: 'number'
        },
      },
      relations: {
        measureId: {
          name: 'measureId',
          type: 'QualityMeasure',
          model: 'QualityMeasure',
          relationType: 'belongsTo',
                  keyFrom: 'measure_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/QualityMeasureValue.ts